import { render, staticRenderFns } from "./OEditLocationStand.vue?vue&type=template&id=5c00628c&"
import script from "./OEditLocationStand.vue?vue&type=script&lang=js&"
export * from "./OEditLocationStand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports